import { Box } from '@mui/material';
import Breadcrumbs from 'components/breadcrumbs';
import Paper from 'components/paper';
import OrderFeedTabsHeader from 'views/order-feed/components/order-feed-tabs-header';
import FilterSidebar from 'components/filter-sidebar';
import { useAccountState } from 'contexts/account/account-context';
import { SiteAutocomplete } from 'views/order-feed/components/site-autocomplete';
import MySupplyPlanSitesSubTabs from './sites-sub-tabs';

import { useHistory, useParams } from 'react-router-dom';
import { useMemo, useEffect } from 'react';

import { useSitesState } from 'views/order-feed/context/sites-context';
import { OrderFeedProvider } from 'views/order-feed/context/order-feed-context';
import SiteList from 'views/order-feed/features/my-supply-plan/components/site-list';
import { MySupplyPlanParams } from 'views/order-feed/features/my-supply-plan/types/my-supply-plan-params.type';

type Props = {};

const SitesOverview: React.FC<Props> = () => {
  const history = useHistory();
  const { siteTab } = useParams<MySupplyPlanParams>();
  const {
    account: { company },
  } = useAccountState();

  const {
    sitesQuery: { data: sitesData },
  } = useSitesState();

  const { activeCount, inactiveCount } = useMemo(() => {
    const act = sitesData?.filter((s) => s.hasRecentOrders).length ?? 0;
    const inact = sitesData?.filter((s) => !s.hasRecentOrders).length ?? 0;
    return { activeCount: act, inactiveCount: inact };
  }, [sitesData]);

  useEffect(() => {
    if (!siteTab) history.push('/order-feed/supply-plan/sites');
  }, [siteTab, history]);

  return (
    <>
      <OrderFeedTabsHeader utils={<Breadcrumbs />} />
      <Box>
        <FilterSidebar>
          <SiteAutocomplete
            value={null}
            route={{
              basePath: '/order-feed/supply-plan',
              getPath: (site) =>
                company?.features.hasOrderFreeDelivery2 && site.isOfd2Enabled
                  ? `/order-feed/supply-plan/order-free-delivery/${site.siteErpId}/${site.globalSiteId}/orders`
                  : `/order-feed/supply-plan/${site.siteErpId}/${site.globalSiteId}`,
            }}
          />
        </FilterSidebar>
      </Box>

      <MySupplyPlanSitesSubTabs aSites={activeCount} iSites={inactiveCount} />

      <Paper
        transparent
        sx={{
          display: 'flex',
          borderTopLeftRadius: { xs: 0, md: '1rem' },
          flexDirection: 'column',
          gap: 4,
        }}>
        <SiteList />
      </Paper>
    </>
  );
};

const SitesOverviewContainer: React.FC = () => (
  <OrderFeedProvider>
    <SitesOverview />
  </OrderFeedProvider>
);

export default SitesOverviewContainer;
